module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy_en.0d081ed81f70f3575338d9ab4756c679.png";